
import { defineComponent } from "vue";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import IButton from "@/components/buttons/IButton.vue";
import { useI18n } from "vue-i18n";
import { mapGetters } from "vuex";
import { RootGetters } from "@/store/getters";
import { filterBy } from '@progress/kendo-data-query';

export default defineComponent({
  name: "DropdownSelect",
  setup() {
    const {t} = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t }
  },
  data() {
    return {
      selected: this.prefill,
      items: []
    };
  },
  computed: {
    ...mapGetters({
        activeCase: RootGetters.GET_ACTIVE_CASE,
        activeSlide: RootGetters.ACTIVE_SLIDE,
    }),
  },
  mounted() {
    this.selected = this.prefill ? this.prefill : this.t('component.dropdown.placeholder');
    this.items = this.options.slice()
  },
  props: {
    prefill: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array<String>,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange() {
      this.$emit("update:modelValue", !this.items.includes(this.selected) ? '' : this.selected);
    },
    resetSelection() {
      this.selected = this.t("component.dropdown.placeholder");
      this.handleChange();
    },
    filterChange (event) {
      this.items = this.filterData(event.filter);
    },
    filterData(filter) {
        const data = this.options.slice();
        return filterBy(data, filter);
    },
  },
  components: {
    "dropdownlist": DropDownList,
    IButton,
},
  watch: {
    prefill(newVal, oldVal) {
      this.selected = newVal ? newVal : this.t("component.dropdown.placeholder");
    },
  },
});
